/**
 * SCRUM-151 — flujo canónico de onboarding.
 *
 * Tres ramas gobernadas por capacidad real del producto:
 *  1. self_service — cobrar → provisionar tenant solo post-pago
 *  2. lead         — capturar interés (self-service OFF); tenant solo por admin
 *  3. trial        — solicitud sin cobro; policy vigente = MANUAL (pending_approval
 *                    hasta approve admin → workspace free_trial). Documentado en
 *                    GA-15 (`trial_request: MANUAL`). No auto-provisiona.
 *
 * CTAs canónicos:
 *  - pago:  ContratarModal mode="payment" (landings + /contratar)
 *  - trial: ContratarModal mode="trial"   (/solicitar-trial + CTAs trial)
 *  - lead:  OnboardingLeadForm / submitPlatformLead → POST /api/leads
 */

export type OnboardingBranch = "self_service" | "lead" | "trial";

/** Session API usa `trial`; suscripciones/flags usan `free_trial`. */
export function normalizeOnboardingPlanId(planId: string | null | undefined): string {
  const id = (planId ?? "").trim().toLowerCase();
  if (id === "trial") return "free_trial";
  return id;
}

/** Plan id válido para POST /api/self-service/session action=start. */
export function toSelfServiceSessionPlanId(planId: string | null | undefined): string {
  const id = (planId ?? "").trim().toLowerCase();
  if (id === "free_trial") return "trial";
  return id;
}

export function resolveOnboardingBranch(input: {
  selfServiceEnabled: boolean | null | undefined;
  intent?: "payment" | "trial" | "lead" | null;
}): OnboardingBranch {
  if (input.intent === "trial") return "trial";
  if (input.intent === "lead") return "lead";
  if (input.selfServiceEnabled === false) return "lead";
  return "self_service";
}

/** Nicho desde query CTA (?profile= / ?niche= / ?rubro=). */
export function nicheFromSearchParams(search: string | URLSearchParams): string | undefined {
  const q = typeof search === "string" ? new URLSearchParams(search) : search;
  const raw = (q.get("profile") ?? q.get("niche") ?? q.get("rubro") ?? "").trim();
  return raw || undefined;
}
